/**
 * RICS taxonomy id. Single source of truth — `next/CustomDash` re-exports this
 * from `filters/utils/ricsTaxonomyTree.ts` (a feature dir cannot be imported by
 * `shared/`, so the constant lives here and the feature points back to it).
 */
export const RICS_TAXONOMY_ID = 1;

/**
 * The full RICS tree projection (k10 → k50 → k400 → company) fetched by the
 * selection-list router. The landing prefetch warms the same request — the
 * levels must stay identical or the page misses the warmed urql cache entry.
 * (Distinct from CustomDash's RICS_TAXONOMY_TREE_LEVELS [1, 3, 4], the
 * k50-less company-picker projection.)
 */
export const RICS_FULL_TAXONOMY_TREE_LEVELS = [1, 2, 3, 4];
